import "./BulkPatientUploadScreen.scss";
import SearchComponent from "../../shared/components/search/SearchComponent";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import DownloadIcon from "@mui/icons-material/Download";
import commonService from "../../shared/services/common.service";
import AddIcon from "@mui/icons-material/Add";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import {useNavigate} from "react-router-dom";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import CommonService from "../../shared/services/common.service";
import ImportBulkPatientComponent from "./import-bulk-patient/importBulkPatientComponent";
import BulkPatientListTableComponent from "./bulk-patient-list-table/bulkPatientListTableComponent";

interface BulkPatientUploadComponentProps {

}

const FiltersInitialState: any = {
    search: '',
}
const BulkPatientUploadScreen = (props: BulkPatientUploadComponentProps) => {
    const [isImportPatientDrawerOpen, setIsImportPatientDrawerOpen] = React.useState<boolean>(false);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [istemplateDownloading, setIsTemplateDownloading] = useState<boolean>(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        dispatch(setCurrentNavParams("Bulk Patient Upload", "Patient"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch, navigate]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    const downloadTemplate = useCallback(() => {
        setIsTemplateDownloading(true);
        CommonService._patient.downloadBulkPatientTemplate()
            .then((res: any) => {
                commonService.downloadFile(res?.data?.url, 'bulk-patient-template.xlsx', 'xlsx')
            })
            .catch(() => {
                commonService._alert.showToast('Something went wrong while downloading template');
            }).finally(() => {
            setIsTemplateDownloading(false);
        })
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
            };
            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData]);

    return (
        <div className={'bulk-patient-list-screen screen'}>
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Bulk Patient"}
                                id="search_input"
                                placeholder={""}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>

                        <div className="page-extra-options">
                            <ButtonComponent
                                type="button"
                                id="template_btn"
                                color={"secondary"}
                                variant={"contained"}
                                isLoading={istemplateDownloading}
                                fullWidth={false}
                                handleClick={() => {
                                    downloadTemplate();
                                }}
                                startIcon={<DownloadIcon/>}
                            >
                                Download Template
                            </ButtonComponent>
                            {
                                commonService.checkAccess('Patient', "patientAdd", currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    color={"primary"}
                                    variant={"contained"}
                                    id="add_bulk_patient_button"
                                    handleClick={() => {
                                        setIsImportPatientDrawerOpen(true)
                                    }}
                                    startIcon={<AddIcon/>}
                                >
                                    Import File
                                </ButtonComponent>
                            }
                        </div>
                    </div>

                    <>
                        <BulkPatientListTableComponent filterData={filterData}/>
                    </>
                </div>
            </div>

            <DrawerComponent open={isImportPatientDrawerOpen}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             title={"Import Bulk Patient File"}
                             onClose={() => setIsImportPatientDrawerOpen(false)}
            >
                <>
                    <ImportBulkPatientComponent/>
                </>
            </DrawerComponent>

        </div>
    );

};

export default BulkPatientUploadScreen;
